import styled from '@emotion/styled';
import { navigation } from 'src/assets/colors';
import { fontWeight } from 'src/assets/fonts-config';
import { ChevronIcon } from 'src/assets/new-icon/ChevronIcon';
import { easeOpacity } from 'src/domains/layouts/shared/animation/AnimationAndTransition.style';

export const MenuItemsNavigation = styled('nav', { label: 'MenuItemsNavigation' })`
    background-color: ${navigation.bgColor};
    flex: 0 0 100%;
    padding: 8px;
    width: 100%;
`;

interface MenuButtonWrapperType {
    isActive: boolean;
    onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
    hasCounter?: boolean;
}

export const MenuButtonWrapper = styled('button', { label: 'MenuButtonWrapper' })<MenuButtonWrapperType>`
    background-color: ${({ isActive }): string => isActive ? navigation.bgColorTabActive : 'transparent'} !important;
    border-radius: 4px;
    border: 0;
    color: ${({ isActive }): string => isActive ? navigation.txtColorActive : navigation.txtColor};
    cursor: pointer;
    font-family: var(--fontFamilyPrimary);
    font-size: 14px;
    font-weight: ${fontWeight.medium};
    height: 32px;
    line-height: 1.3334;
    overflow: hidden;
    padding: ${({ hasCounter }): string => hasCounter === true ? '7px 48px 8px 8px' : '7px 28px 8px 8px'};
    position: relative;
    text-align: left;
    text-overflow: ellipsis;
    transition: color .2s ease;
    white-space: nowrap;
    width: 100%;
    z-index: 0;
    &:not(:last-of-type) {
        margin-bottom: 8px;
    }
    &::before {
        background-color: ${navigation.bgColorTabActive};
        bottom: 0;
        content: '';
        left: 0;
        opacity: 0;
        position: absolute;
        right: 0;
        top: 0;
        transition: ${easeOpacity};
        z-index: -1;
    }
    &:hover {
        color: ${navigation.txtColorActive};
        > div {
            color: ${navigation.txtColorCounterActive};
            background-color: ${navigation.bgColorTab};
        }
        &::before {
            opacity: 1;
        }
    }
`;

type ArrowIconWrapperType = Pick<MenuButtonWrapperType, 'isActive'>

export const ArrowIconWrapper = styled(ChevronIcon, { label: 'ArrowIconWrapper' })<ArrowIconWrapperType>`
    bottom: 0;
    fill: currentColor;
    margin: auto 0;
    position: absolute;
    right: 4px;
    top: 0;
    transition: fill .2s ease;
`;


type MenuCounterType = Pick<MenuButtonWrapperType, 'isActive'>

export const MenuCounter = styled('div', { label: 'MenuCounter' })<MenuCounterType>`
    align-items: center;
    background-color: ${({ isActive }): string => isActive ? navigation.bgColorTab : navigation.bgColorTabActive};
    border-radius: 50%;
    bottom: 0;
    color: ${({ isActive }): string => isActive ? navigation.txtColorCounterActive : navigation.txtColorCounter};
    display: flex;
    font-family: var(--fontFamilyPrimary);
    font-size: 7px;
    font-weight: ${fontWeight.bold};
    height: 16px;
    justify-content: center;
    line-height: 1;
    margin: auto 0;
    position: absolute;
    right: 28px;
    top: 0;
    transition: background-color .2s ease, color .2s ease;
    width: 16px;
`;
